export type StudentHelperPreparationStatus =
  | "inactive"
  | "processing"
  | "completed"

type InactiveDTO = {
  progress: number
  status: "inactive"
  preparation_task_id?: never
  created?: never
  updated?: never
}
type ProcessingDTO = {
  progress: number
  status: "processing"
  preparation_task_id: string
  created: string
  updated: string
}
type CompletedDTO = {
  progress: number
  status: "completed"
  preparation_task_id: string
  created: string
  updated: string
}

export type StudentHelperAssignmentPreparationStatusDTO =
  | InactiveDTO
  | ProcessingDTO
  | CompletedDTO

export class StudentHelperAssignmentPreparationStatus {
  constructor(
    progress: number,
    status: "inactive",
    preparationTaskId?: never,
    created?: never,
    updated?: never,
  )
  constructor(
    progress: number,
    status: "processing" | "completed",
    preparationTaskId: string,
    created: Date,
    updated: Date,
  )
  constructor(
    public readonly progress: number,
    public readonly status: StudentHelperPreparationStatus,
    public readonly preparationTaskId?: string,
    public readonly created?: Date,
    public readonly updated?: Date,
  ) {}

  static fromDTO(
    dto: StudentHelperAssignmentPreparationStatusDTO,
  ): StudentHelperAssignmentPreparationStatus {
    switch (dto.status) {
      case "inactive":
        return new StudentHelperAssignmentPreparationStatus(
          dto.progress,
          dto.status,
        )
      case "processing":
      case "completed":
        return new StudentHelperAssignmentPreparationStatus(
          dto.progress,
          dto.status,
          dto.preparation_task_id,
          new Date(dto.created),
          new Date(dto.updated),
        )
    }
  }

  toDTO(): StudentHelperAssignmentPreparationStatusDTO {
    switch (this.status) {
      case "inactive":
        return {
          progress: this.progress,
          status: this.status,
        }
      case "processing":
      case "completed":
        if (typeof this.preparationTaskId !== "string") {
          throw new Error("preparationTaskId must be a string")
        }
        if (!(this.created instanceof Date)) {
          throw new Error("created must be a Date")
        }
        if (!(this.updated instanceof Date)) {
          throw new Error("updated must be a Date")
        }

        return {
          progress: this.progress,
          status: this.status,
          preparation_task_id: this.preparationTaskId,
          created: this.created.toISOString(),
          updated: this.updated.toISOString(),
        }
    }
  }
}
